<template>
  <div class="personal-center-page">
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">实时查看</h1>
        </div>
      </div>
    </div>

    <!-- 金色banner卡片 -->
    <div
      class="golden-banner"
      :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
    >
      <img
        src="@/assets/college/vip-card/card.png"
        alt="卡片背景"
        class="card-background"
      />
      <!-- 原 Logo 模板保留，恢复方式见 college/config.js 的 showShandongUniversityLogo 开关。 -->
      <img
        v-if="collegeName[productId].showLogo !== false"
        :src="collegeName[productId].logoCard"
        alt="logo"
        class="logo-image"
      />
      <img
        src="@/assets/college/vip-card/vip.png"
        alt="vip"
        class="vip-image"
      />
      <img
        src="@/assets/college/vip-card/super.png"
        alt="super"
        class="super-image"
      />
      <img
        src="@/assets/college/vip-card/text.png"
        alt="text"
        class="text-image"
      />
    </div>

    <!-- 我的操作区域 -->
    <div class="operations-section">
      <div class="section-title-row">
        <h3 class="section-title">我的操作</h3>
        <div class="back-action" @click="goBack">
          <van-icon name="revoke" size="18px" />
          <span>返回</span>
        </div>
      </div>
      <div class="operation-icons">
        <div class="operation-item" @click="goToVideoList">
          <div class="icon-circle">
            <img :src="operateIcon2" alt="历史视频" class="operate-icon" />
          </div>
          <span class="icon-label">历史视频</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import operateIcon2 from "@/assets/client/operate_icon_2.png";
import { college } from "../college/config";

export default {
  name: "RealtimeMenu",
  data() {
    return {
      operateIcon2: operateIcon2,
      personPrivilgeId: this.$route.query.personPrivilgeId || "",
      collegeName: college,
      productId: '0'
    };
  },
   created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = urlParams.get("productId") || localStorage.getItem("productId") || "0";
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToVideoList() {
      this.$router.push({
        path: "/client/video-list",
        query: {
          personPrivilgeId: this.personPrivilgeId,
          productId: this.productId,
        },
      });
    },
  },
};
</script>

<style scoped src="../college/logo-layout.css"></style>

<style scoped lang="less">
.personal-center-page {
  min-height: 100vh;
  background: #fff;
  position: relative;
  padding-bottom: 90px; /* 为固定的退出按钮留出空间 */
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.back-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #bb7849;
  padding: 6px 12px;
  border-radius: 16px;
  background: rgba(255, 243, 226, 0.88);
  box-shadow: 0 2px 6px rgba(255, 179, 71, 0.25);
}

.back-action:active {
  opacity: 0.85;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 页面标题 */
.page-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
}

.page-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 金色banner卡片 */
.golden-banner {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -160px;
}

.card-background {
  width: 100%;
  height: auto;
  display: block;
}
.logo-image {
  position: absolute;
  width: 200px;
  left: 40px;
  top: 20px;
}
.text-image {
  position: absolute;
  width: 280px;
  left: 40px;
  top: 80px;
}
.super-image {
  position: absolute;
  width: 50px;
  left: 40px;
  top: 115px;
}
.vip-image {
  position: absolute;
  width: 30px;
  left: 95px;
  top: 111px;
}

/* 我的操作区域 */
.operations-section {
  padding: 0 20px 30px 20px;
  background: white;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
}

.operation-icons {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 40px;
  row-gap: 30px;
}

.operation-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s;
  flex: 0 0 auto;
}

.operation-item:hover {
  transform: translateY(-5px);
}

.icon-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
  img {
    width: 47px;
    height: 47px;
  }
}

.icon-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .header-banner {
    height: 200px;
  }

  .golden-banner {
    padding: 0 15px 15px;
  }

  .icon-circle {
    width: 70px;
    height: 70px;
  }

  .operation-icons {
    gap: 10px;
  }
}
</style>
